import { Component } from '@angular/core';

@Component({
  selector: 'app-cards7-examples-47',
  templateUrl: './cards7-examples-47.component.html'
})
export class Cards7Examples47Component {}
